import type { AddItemVisibility } from 'src/components/add-item/types';
import { useState } from 'react';
import { usePageTitle } from 'src/hooks/use-page-title';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';
import { useTrackPageView } from '@savvy/deprecated-shared/tracking/use-track-page-view';
import { XMobileLayout } from '@savvy/deprecated-shared/x-components/x-mobile-layout';

import { useHouseholdWriteAccess } from '../../hooks/use-household-write-access';
import { DashboardAnnouncements } from '../dashboard/dashboard-announcements';
import { DashboardContent } from '../dashboard/dashboard-content';
import { DashboardLayout } from '../dashboard/dashboard-layout';
import TrackedButton from '../tracked/tracked-button';
import NetWorthPortfolio from './net-worth-portfolio';

export default function NetWorth({ clientUserId }: { readonly clientUserId: string }) {
  useTrackPageView();
  usePageTitle('Savvy | View Your Dashboard');
  const { user } = useAuth();
  const advisorView = !!clientUserId;
  const [showAddItemDialog, setShowAddItemDialog] = useState<AddItemVisibility | undefined>(undefined);
  const isSmallScreen = useIsSmallScreen();
  const announcementUserId = clientUserId || user?.id;

  return isSmallScreen ? (
    <XMobileLayout>
      <div className="flex flex-col h-[97.75vh] bg-primary">
        <NetWorthPortfolio
          clientUserId={clientUserId}
          showAddItemDialog={showAddItemDialog}
          setShowAddItemDialog={setShowAddItemDialog}
        />
      </div>
    </XMobileLayout>
  ) : (
    <DashboardLayout
      headerTitle="Net worth"
      useClientHeader={advisorView}
      headerRightContent={
        <div className="pr-2">
          <AddAccountButton setShowAddItemDialog={setShowAddItemDialog} />
        </div>
      }
    >
      <DashboardContent maxWidth="lg">
        {announcementUserId && <DashboardAnnouncements userId={announcementUserId} />}
        <NetWorthPortfolio
          clientUserId={clientUserId}
          showAddItemDialog={showAddItemDialog}
          setShowAddItemDialog={setShowAddItemDialog}
        />
      </DashboardContent>
    </DashboardLayout>
  );
}

type AddAccountButtonProps = {
  readonly setShowAddItemDialog: (visibility: AddItemVisibility) => void;
};
export function AddAccountButton({ setShowAddItemDialog }: AddAccountButtonProps) {
  const isSmallScreen = useIsSmallScreen();
  const { canWrite } = useHouseholdWriteAccess();
  if (!canWrite) {
    return null;
  }
  return (
    <TrackedButton
      elementName="net-worth-add-account-or-asset-button"
      variant="secondary"
      size={isSmallScreen ? 'default' : 'sm'}
      onClick={() => {
        setShowAddItemDialog('VISIBLE');
      }}
      className="w-full"
    >
      Add account or asset
    </TrackedButton>
  );
}
